export default "__VITE_ASSET__DBfECLdJ__"